import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";

export const SEOSection = ({ settings, onInputChange }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <FileText className="w-5 h-5" />
        SEO & Metadonnees
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="meta_title">
          Meta Title
          <Badge variant="outline" className="ml-2">Max 60 caracteres</Badge>
        </Label>
        <Input
          id="meta_title"
          value={settings.meta_title}
          onChange={(e) => onInputChange("meta_title", e.target.value)}
          placeholder="Titre du site pour les moteurs de recherche"
          maxLength={60}
        />
        <p className="text-xs text-muted-foreground">{settings.meta_title?.length || 0}/60 caracteres</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="meta_description">
          Meta Description
          <Badge variant="outline" className="ml-2">Max 160 caracteres</Badge>
        </Label>
        <Textarea
          id="meta_description"
          value={settings.meta_description}
          onChange={(e) => onInputChange("meta_description", e.target.value)}
          placeholder="Description du site pour les moteurs de recherche"
          rows={3}
          maxLength={160}
        />
        <p className="text-xs text-muted-foreground">{settings.meta_description?.length || 0}/160 caracteres</p>
      </div>
    </CardContent>
  </Card>
);
